import { Icon, Text, makeStyles } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'

interface Props {
  rating?: number
}

export function PastShiftRating({ rating }: Props) {
  const styles = useStyles()
  if (!rating) {
    return null
  }
  return (
    <View style={styles.rating}>
      <Text style={styles.text}>{`Your rating : `}</Text>
      <Icon
        name={'star'}
        type="material-design"
        color={styles.icon.color}
        style={styles.icon}
      />
      <Text style={styles.text}>{rating}</Text>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.colors.primary,
    margin: 5,
  },
  rating: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  ratingText: {
    color: theme.colors.primary,
  },
  text: {
    fontSize: 13,
    color: theme.colors?.grey2,
  },
}))
